import { get } from '@webapp-next/lib/request/webapp/apiv2';

export type StandardDayError = {
  code: string | number;
  details?: [];
  message: string;
};

export type StandardDayData = {
  standardDayCalcMethod: string;
  standardDayHours: number;
  defaultStandardDayHours: number;
};

export type StandardDay = {
  success: boolean;
  data?: StandardDayData | undefined;
  error?: StandardDayError | undefined | string;
};

export async function getStandardDayByEmployeeId(
  employeeId: number | string
): Promise<StandardDayData> {
  const { data: response }: { data: StandardDay } = (await get(
    `/api/management/v2/employees/${employeeId}/standard-day`
  )) as { data: StandardDay };

  if (response?.success === false) {
    throw new Error('Failed to retrieve StandardDay data');
  }

  return response.data as StandardDayData;
}
